export default function parseHeight(heightInInches = 0) {
  const feet = Math.floor(heightInInches / 12);
  const inches = heightInInches % 12;
  const centimeters = heightInInches * 2.54;
  const meters = centimeters / 100;
  return {
    feet,
    inches,
    centimeters: Number(centimeters.toFixed(2)),
    meters: Number(meters.toFixed(2)),
  };
}
